/**
 * Extracted from `components/question-quality/leo-spotted-cell.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import { LEO_SPOTTED_COLUMN_LABEL } from "@/components/question-quality/leo-spotted-column-header"

export { LEO_SPOTTED_COLUMN_LABEL }

/**
 * Leo Spotted sits after question identity and type, before classification
 * and psychometrics (topic, difficulty, Bloom, PBI) on every question table.
 */
export const LEO_SPOTTED_COLUMN = {
  key: "aiSpotted",
  label: LEO_SPOTTED_COLUMN_LABEL,
  width: 200,
  minWidth: 168,
  cellKind: "status",
} as const
